module.exports = __webpack_public_path__ + "static/media/InfoCircle.40098d2b.svg";